export const REDIRECT_POPUP_TIMESTAMP_KEY = 'redirect-popup-timestamp'
export const UI_VERSION = 'ui-version'
